import { BasePage } from '@/components/ui/base-page'

export function SDIPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add SDIPage specific content here */}
    </BasePage>
  )
}